import React from "react";
import {
  Modal,
  ModalFooter,
  ModalInput,
  ModalButton,
  modalConnect,
  ModalBody,
} from "@modal";

import {
  ceModalUploadFromFileSave,
  ceModalUploadFromFileCancel,
  ceModalUploadFromFileLoadFile,
} from "@js/actions/studio/campaign_content_section/modal_upload_from_file.js";

const ModalUploadFromFile = modalConnect((props) => {
  let updateFileFromInput = (e) => {
    let fileObject = e.target.files[0];
    if (fileObject) {
      let reader = new FileReader();
      reader.onload = (loadedReader) => {
        let fileContents = loadedReader.target.result;
        props.dispatch(
          ceModalUploadFromFileLoadFile(
            fileObject,
            fileContents,
            fileObject.size,
          ),
        );
      };
      reader.readAsText(fileObject);
    }
  };

  let saveText = () => {
    props.dispatch(ceModalUploadFromFileSave("text"));
  };

  let saveHTML = () => {
    props.dispatch(ceModalUploadFromFileSave("html"));
  };
  return (
    <Modal
      title={t("phrases.react_content.import_modal.import_as_either")}
      onCancel={() => props.dispatch(ceModalUploadFromFileCancel())}
    >
      <ModalBody>
        <ModalInput
          type="file"
          onChange={updateFileFromInput}
          error={props.validation_error}
        />
        {props.file && (
          <small>
            {t("phrases.react_content.selected_file")}: {props.file.name}
          </small>
        )}
      </ModalBody>
      <ModalFooter>
        <ModalButton
          onClick={() => props.dispatch(ceModalUploadFromFileCancel())}
          text={t("buttons.cancel")}
          diminished
        />
        <ModalButton
          onClick={saveText}
          text={t("phrases.react_content.import_modal.import_text")}
          dangerous={props.validation_error}
          diminished={!props.file}
        />
        <ModalButton
          onClick={saveHTML}
          text={t("phrases.react_content.import_modal.import_html")}
          dangerous={props.validation_error}
          diminished={!props.file}
        />
      </ModalFooter>
    </Modal>
  );
});
export default ModalUploadFromFile;
